firebird.factory('videoParamsService', [
    '$window',
    'logService',
    'helperService',
    'meetingService',
    'configService',
    'analyticsWrapperService',
    'videoGlobalService',
    'virtualBackgroundService',
    'executionEnvironmentEnum',
    function (
        $window,
        logService,
        helperService,
        meetingService,
        configService,
        analyticsWrapperService,
        videoGlobalService,
        virtualBackgroundService,
        executionEnvironmentEnum
    ) {
        var service = {
            initialize: initialize
        };

        var self;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoParamsService');

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.applyQueryParameters = applyQueryParameters;
            self.updateFlagsObject = updateFlagsObject;
            self.setConfigObjectFromValue = setConfigObjectFromValue;

            self.flagsObject = null;

            //IF YOU UPDATE THIS PAYLOAD: please update the corresponding payload object in Meeting Service janus.js
            self.sfuPayload = {
                mediapath: undefined,
                videocodec: undefined,
                audiocodec: undefined,
                videoBitrate: undefined,
                videoFramerate: undefined,
                adjustBitrate: undefined,
                videoLowCount: undefined,
                useEncodeTime: undefined,
                frozenWorkaround: undefined,
                brokenMediaPath: undefined,
                videoRoomOptions: undefined,
                frameRate: undefined,
                frameRateScreen: undefined,
                frameRateFile: undefined,
                adjustOnQualityLimitation: undefined,
                enableAvailableIncomingBitrate: undefined,
                adjustOnHighBandwidth: undefined,
                adjustOnWindowSize: undefined,
                adjustOnVideoLow: undefined,
                adjustOnSlowLink: undefined,
                adjustMaxCutoff: undefined,
                adjustSubstream: undefined,
                videoLowConfig: undefined,
                videoLowBitrate: undefined,
                bitrateLow: undefined,
                maxVideosSize: undefined,
                layoutTrigger: undefined,
                layoutOrder: undefined,
                layoutMethod: undefined,
                layoutLock: undefined,
                layoutMove: undefined,
                layoutRecord: undefined,
                layoutPin: undefined,
                layoutPage: undefined,
                layoutPageReuse: undefined,
                layoutPreview: undefined,
                layoutSelfPIP: undefined,
                statsReduce: undefined,
                layoutDebug: undefined,
                detectScreenAppMute: undefined,
                showPicOnAppMin: undefined,
                mediapipe: undefined,
                multishare: undefined,
                multisharePrompt: undefined,
                multishareRecord: undefined,
                simulcastEnabled: undefined,
                useSimulcast2: undefined,
                cdrDebug: undefined,
                speedtest: undefined,
                speedtestWait: undefined,
                audioStereo: undefined,
                videoFilterConfig: undefined,
                featureFlags: undefined,
                remoteFlags: undefined,
                iceTransportOnTCP: undefined,
                iceRestartOnAudio: undefined,
                networkState: undefined,
                refactorPublisherId: undefined,
                publisherIdSize: undefined,
                detectIceChange: undefined,
                useSdpParser: undefined,
                trackCandidates: undefined,
                qualityBars: undefined,
                reduceSubstreamChange: undefined,
                pauseOnBackground: undefined,
                reducePublisherAdjust: undefined,
                enablePortraitRecord: undefined,
                enableSimulcastToggle: undefined
            };
        }

        // read query parameters or local storage and apply values.
        function applyQueryParameters() {
            logService.log('videoroomCtrl - applyQueryParameters');

            var settings = configService.readStorage(meetingService.getMeetingCode());

            if (Object.keys(settings).length > 0) {
                var featureFlags = { sfuEvent: true };
                for (var attr in settings) {
                    featureFlags[attr] = settings[attr];
                }
                logService.log('videoroomCtrl - feature-flags - client ' + JSON.stringify(settings));
                analyticsWrapperService.eventTrack('Meeting - feature-flags - client', featureFlags);
                self.msgflowEvent('feature flags', settings);
            }

            // TODO: for correct handling, it should always set self.property to default value before using parameter.
            // this makes the function re-entrant. otherwise, old value is not cleared if parameter is reset on second call.

            self.initTestvideos();
            self.initTalkerLayout();
            self.initStats();
            self.initMedia();
            self.initMediaPath();
            // Here we checking do we need to enable e2ee based on initial payload (salt, especially)
            self.initE2EE();
            self.initSimulcast(); // must be after initMedia
            self.initSimulcastToggle(); // must be after initSimulcast
            self.initSimulcastFlag(); // must be after initSimulcast and initSimulcastToggle
            self.initVideoLow();
            self.initStatsFrozen(); // must be after initStats
            self.initBitrate(); // needed before initSimulcast2
            self.initSimulcast2();
            self.initVideoLowAlt(); // must be after initSimulcast2
            self.initMediaConstraints();
            self.initSpeedTest();
            self.initLayout();
            self.initLayoutMove();
            self.initLayoutLock();
            self.initPopout();
            self.initLayoutPin();
            self.initLayoutReuse();
            self.initLayoutPage(); // after initVideoLow and initMediaConstraints
            self.initLayoutPreview(); // after initLayoutPage
            self.initScreenShare();
            self.initContentState();
            self.initFeatureFlags();
            self.initTouchBar();
            self.initVideoOnScreen();
            self.initVideoSize();
            self.initKeyFrame();
            self.initVideoToggle();
            self.initAudioBitrate();
            self.initFaceTrack();
            self.initVideoCanvas();
            self.initReconnect();
            self.initConnect();
            self.initPublisherId();
            self.initPlay(); // must be after initSimulcastToggle
            self.initStatsQualityBars();

            // change some settings when e2ee enabled (we'll restore them after e2ee disabled)
            if (meetingService.e2eeEnabled()) {
                self.e2eeChangeSettings(true);
            }

            self.updateFlagsObject();
        }

        function updateFlagsObject() {
            //Update User Flags Obj to be sent to Fireflow
            //For consistency, flag values should all be strings
            var newFlagsObj = {};
            for (var payloadAttr in self.sfuPayload) {
                var flagValue = configService.getValue(payloadAttr) || undefined;
                if (flagValue) {
                    newFlagsObj[payloadAttr] = flagValue;
                }
            }

            if (meetingService.getEnableAutoPerformanceMode()) {
                //This indicates that the User Pair was present, but not if the client was actually in Performance Mode at this time
                newFlagsObj.enableAutoPerformanceMode = 'true';
            }

            if (
                virtualBackgroundService.getVirtualBackground() &&
                helperService.getQueryParameter('videoFilter') !== 'false'
            ) {
                newFlagsObj.videoFilter = 'true';
            }

            if (self.iceTransportPolicy !== 'all') {
                newFlagsObj.iceTransportPolicy = self.iceTransportPolicy;
            }

            if (self.iceTransportOnTCP) {
                newFlagsObj.iceTransportOnTCP = self.iceTransportOnTCP;
            }

            if (self.email && self.email.indexOf('intermedia.') >= 0) {
                // possibly internal user.
                newFlagsObj.internal = 'true';
            }

            const vdiType = helperService.getVDIRef().getVdiType();
            if (vdiType && vdiType !== executionEnvironmentEnum.NonVDI) {
                newFlagsObj.vdiType = vdiType;
            }

            self.flagsObject = Object.keys(newFlagsObj).length > 0 ? newFlagsObj : null;
        }

        function setConfigObjectFromValue(name, value, obj, defaultConfig) {
            if (!value) {
                obj.enabled = false;
                if (defaultConfig) {
                    Object.assign(obj, defaultConfig);
                }
                return;
            }
            logger.log('setConfigObjectFromValue', `set ${name} from ${value}, previous=`, obj);
            if (defaultConfig) {
                Object.assign(obj, defaultConfig);
            }
            if (value === 'true') {
                obj.enabled = true;
            } else if (value === 'false') {
                obj.enabled = false;
            } else {
                obj.enabled = !!value; // optional if other sub-flags present
                self.setConfigObjectFromCSV(obj, value);
            }
        }
    }
]);
